export function replaceUrlWithoutAnyEffect(newUrl: string) {
  if (typeof window !== 'undefined') {
    window.history.replaceState({}, '', newUrl);
  }
}

export const getOpenNewTab = (pageUrl: string) => () => window.open(pageUrl, '_blank', 'noopener noreferrer');
export const openInNewTab = (pageUrl: string) => getOpenNewTab(pageUrl)();
